import {
  getItemColor,
  isDynamicWorkspaceItem,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { muiColorPalette } from '@pn/services/color/colorPalettes';

/* Picks a color not yet used by another temporary dynamic item. */
export function getNextFilterColor(
  allWorkspaceItems: Record<WorkspaceItem['id'], WorkspaceItem>
): string {
  const usedColors = Object.values(allWorkspaceItems)
    .filter((item) => item.isTemporary && isDynamicWorkspaceItem(item))
    .map((item) => getItemColor(item) as string);

  return muiColorPalette.getFilterColor(usedColors);
}
